var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 0.75,
    x2: 36,
    y2: 99.25,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51842a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#609631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#6da737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#77b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#7ebb3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#83c140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85c441"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fillOpacity: 0,
    stroke: "#528228",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 91.3l5.4-8.2-4.9-7.5h3.7l3.2 5 3.1-5h3.7l-4.9 7.6 5.4 8.1h-3.8l-3.5-5.4-3.5 5.4H7.3zm16.3 0V75.7h3.2v12.9h7.9v2.6H23.6zm12.6-5.1l3.1-.3c.2 1 .6 1.8 1.1 2.3.6.5 1.3.7 2.3.7 1 0 1.8-.2 2.3-.6s.8-.9.8-1.5c0-.4-.1-.7-.3-.9s-.6-.5-1.1-.7c-.4-.1-1.2-.4-2.5-.7-1.7-.4-2.9-.9-3.6-1.6-1-.9-1.5-1.9-1.5-3.2 0-.8.2-1.5.7-2.2.5-.7 1.1-1.2 2-1.6.9-.4 1.9-.5 3.1-.5 2 0 3.5.4 4.5 1.3s1.5 2 1.6 3.5l-3.2.1c-.1-.8-.4-1.4-.9-1.7-.4-.4-1.1-.5-2-.5-.9 0-1.6.2-2.2.6-.3.2-.5.6-.5 1s.2.7.5 1c.4.3 1.4.7 2.9 1 1.5.4 2.7.7 3.4 1.1.7.4 1.3.9 1.7 1.6.4.7.6 1.5.6 2.5 0 .9-.3 1.7-.8 2.5-.5.6-1.2 1.2-2.1 1.6-.9.4-2.1.6-3.4.6-2 0-3.5-.5-4.6-1.4-1.1-.9-1.7-2.3-1.9-4zm13.9 5.1l5.4-8.2-4.9-7.5h3.7l3.2 5 3.1-5h3.7l-4.9 7.6 5.4 8.1H61l-3.5-5.4-3.5 5.4h-3.9z",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.371,
    y1: 36.987,
    x2: 55.488,
    y2: 76.103,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#619530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#60942f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#5b8e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#538429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#487723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#3a671b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#29520f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244d0b"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 61.4H35.2v-2c2.2-.1 3.5-.3 4.2-.6.6-.3.9-.6.9-1 0-.2-.1-.6-.3-1.1-.2-.5-.5-1.1-.9-1.7-.6-1-1.4-2.3-2.4-3.8s-2.1-3.1-3.2-4.8c-3.6 4.2-6 7-6.9 8.4-1 1.4-1.5 2.3-1.5 2.8 0 .2 0 .4.1.6.1.2.3.3.6.5.2.1.7.3 1.3.4.6.1 1.3.2 2.1.3v2H14.8v-2c.7-.1 1.3-.1 1.8-.2.4-.1.9-.2 1.3-.4 1-.5 1.9-1.1 2.7-1.8s1.6-1.6 2.4-2.5c1.2-1.4 2.6-2.9 4.1-4.7 1.5-1.7 3.1-3.6 4.8-5.6-1.6-2.4-3.2-4.8-4.8-7-1.6-2.3-3-4.2-4.1-5.8-.6-.8-1.2-1.6-2.1-2.4-.8-.8-1.7-1.4-2.6-1.7-.5-.2-1-.4-1.5-.5-.6-.1-1.2-.2-2-.3v-2h22.6v2c-1.8.1-3.1.2-3.9.5-.8.2-1.3.6-1.3 1.1 0 .2.1.6.2.9.2.4.5 1 1 1.8.4.7 1.1 1.7 1.9 3 .9 1.3 1.9 2.9 3 4.6 3.3-3.9 5.3-6.5 6.2-7.6.8-1.2 1.3-2 1.3-2.4 0-.5-.2-.9-.7-1.1-.5-.3-1.6-.5-3.4-.6v-2h14.4v2c-.7 0-1.2.1-1.6.2-.4.1-.9.3-1.5.5-1.1.5-2 1.1-2.7 1.8-.7.7-1.5 1.5-2.4 2.5-1.3 1.4-2.5 2.8-3.7 4.2-1.2 1.3-2.6 3-4.3 4.9 2.1 3.2 3.9 5.8 5.4 7.9 1.5 2.1 2.9 4.1 4.3 6 .5.8 1.2 1.6 2 2.4.8.8 1.7 1.4 2.6 1.7.4.2.9.3 1.4.4.5.1 1.3.2 2.1.3v1.9h.1z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 45.034,
    y1: 72.352,
    x2: 58.534,
    y2: 85.852,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#f0f4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#e8eeca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#dde7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#cfddad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#bed298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a9c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#91b566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#78a647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#619932"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fillOpacity: 0,
    stroke: "#528228",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.f9fb408e17548c3af579a20e9d4fc51d.svg";
export { ForwardRef as ReactComponent };